import * as React from 'react';
import inputMethod from "../lib/inputMethod";
// FocusHandler contains all of the logic necessary to determine whether an
// element is focused and the input method used to focus the element.
// You just have to bring your own element.
//
// FocusHandler passes two arguments to its children:
//
//   props - The props necessary to determine the focus of an element.
//     These props should be passed to the focusable element.
//
//   method - The input method used to focus the element.
//     If the input method is null, the element is not focused.
//
// FocusHandler is the first example of an experimental pattern to define
// reusable components that encapsulate stateful logic without rendering any
// output. In the future, these can potentially be powered by React hooks.
// Questions? Ping @koop in #sail.
class FocusHandler extends React.Component {
  constructor(...args) {
    super(...args);
    this.state = {
      method: null
    };
    this.onFocus = event => {
      if (this.props.stopPropagation) {
        event.stopPropagation();
      }
      this.setState(() => ({
        method: inputMethod.getState()
      }));
    };
    this.onBlur = event => {
      if (this.props.stopPropagation) {
        event.stopPropagation();
      }
      this.setState({
        method: null
      });
    };
  }
  componentDidMount() {
    inputMethod.mount();
  }
  componentWillUnmount() {
    inputMethod.unmount();
  }
  render() {
    const {
      onBlur,
      onFocus
    } = this;
    return this.props.children({
      onBlur,
      onFocus
    }, this.state.method);
  }
}
export default FocusHandler;